import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import EBookForm from '../components/ebooks/EBookForm';
import { mediaService, ebookService } from '../services';
import toast from 'react-hot-toast';
import { serverTimestamp } from 'firebase/firestore';

// Temporary in-memory store (placeholder until services are wired)
const mockGetById = (id: string | undefined) => {
  if (!id) return null;
  if (id === '1') {
    return {
      id: '1',
      title: 'The Great Gatsby',
      description: 'A classic American novel set in the Jazz Age.',
      author: 'F. Scott Fitzgerald',
      category: { name: 'fiction' },
      isPublished: true,
      isFeatured: true,
      isPremium: false,
      coverImage: { url: '/api/placeholder/100/150' },
      file: { fileName: 'great-gatsby.pdf' },
    } as any;
  }
  return null;
};

const EBookUpsert: React.FC = () => {
  const navigate = useNavigate();
  const { id, view } = useParams<{ id: string; view?: string }>();

  const isEdit = Boolean(id);
  const isView = window.location.pathname.includes('/view');
  const [ebook, setEbook] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    const load = async () => {
      if (id) {
        setLoading(true);
        try {
          const result = await ebookService.getEBook(id);
          if (result.success) setEbook(result.data);
        } catch (e) {
          toast.error('Failed to load e-book');
        } finally {
          setLoading(false);
        }
      } else {
        setEbook(mockGetById(id));
      }
    };
    load();
  }, [id]);

  const [saving, setSaving] = useState(false);
  
  const handleSubmit = async (success: boolean) => {
    if (success) {
      navigate('/ebooks');
    }
  };

  const handleCancel = () => navigate('/ebooks');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{isEdit ? 'Edit E-book' : 'Add New E-book'}</h1>
          <p className="text-gray-600 mt-1">{isEdit ? 'Update the e-book information' : 'Create a new e-book entry'}</p>
        </div>
      </div>
      {loading ? (
        <div className="p-6">
          <p>Loading...</p>
        </div>
      ) : (
        <EBookForm
          ebook={ebook}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={saving}
          readOnly={isView}
        />
      )}
    </div>
  );
};

export default EBookUpsert;


